// External Dependencies
import * as Sentry from '@sentry/react';

// Local Dependencies
import { getEnvironmentLabel } from './environment-helpers';

export const initializeSentry = () => {
  const environmentLabel = getEnvironmentLabel(window.location);

  // Initialize Sentry
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: environmentLabel,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    tracePropagationTargets: [
      // allows traces in prod. Allows text-em-all.com and call-em-all.com
      /^https:\/\/payments\.(text|call)-em-all\.com\//,
    ],
    replaysSessionSampleRate: 0.0, // Don't capture any sessions by default. We'll only capture sessions where an error occurs
    replaysOnErrorSampleRate: 1.0,
  });
};
